
export interface TokenPackage {
  id: string;
  tokens: number;
  price: number;
  popular?: boolean;
}

export const TOKEN_PACKAGES: TokenPackage[] = [
  { id: 'starter', tokens: 50000, price: 1.99 },
  { id: 'popular', tokens: 100000, price: 3.49, popular: true },
  { id: 'best-value', tokens: 200000, price: 5.99 }
];
